module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section01_03_beach-photo-2dde1f7accdf7f475938604db7062a60.jpg";